export const navigateSerial = (link, serial_id = 0, serie_id = 0) => {
  switch (link) {
    case "serial":
      return `/serial/${serial_id}`;

    case "serial-seasons":
      return `/serial/${serial_id}/seasons/`;

    case "serial-series":
      return `/serial/${serial_id}/series/`;

    case 'create-serie':
      return `/serial/${serial_id}/series/${serie_id}`;

    case 'massAddition':
      return `/serial/${serial_id}/mass-addition`

    case 'order':
      return `/serial/${serial_id}/order`

    default:
      return `/serial/${serial_id}`;
  }
};
